module.exports = __webpack_public_path__ + "static/media/dedicated-linux-server-br.e65a348c.png";